import React, { useEffect, useRef } from "react";
import { canonicalAppUrl } from "../lib/canonicalOrigin";
import { isNativeApp } from "../lib/platform";

export const CanonicalOrigin = ({ children }) => {
  // В нативной оболочке страница живёт на локальных ассетах — никаких
  // переходов на веб-origin, иначе теряется мост Capacitor (push, камера).
  const target = isNativeApp() ? null : canonicalAppUrl(window.location.href, process.env.REACT_APP_BACKEND_URL);
  const redirected = useRef(false);
  useEffect(() => {
    if (target && !redirected.current) {
      redirected.current = true;
      window.location.replace(target);
    }
  }, [target]);
  if (!target) return children;
  return <main data-testid="canonical-origin-redirect" style={{ minHeight: "100dvh", display: "flex",
    flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 16, padding: 24,
    background: "#0A0A0A", color: "#D4B878", fontFamily: "Manrope", textAlign: "center" }}>
    <p role="status" data-testid="canonical-origin-status">Открываем Angiolini…</p>
    <a href={target} data-testid="canonical-origin-link" style={{ color: "#e7d5b0", textDecoration: "underline" }}>Перейти в приложение</a>
  </main>;
};